<template>
  <div id="infoWrap" class="info">
    <ul class="login_info" v-if="roleName">
      <li v-if="isindex == 1 && roleName.roleName != 'tcadmin'" style="width: 70px">
        <a v-if="roleName.roleName == 'sysadmin'" :href="isindex == 1
            ? getIplatPath() +
            '/html/' +
            roleName.roleName +
            '/school_admin.html'
            : getIplatPath() + '/dist/index.html'
          ">用户中心</a>
        <!-- <a v-if="roleName.roleName=='sysadmin'" :href="getIplatPath()+'/html/'+roleName.roleName+'/school_admin.html'">用户中心</a> -->
        <a v-else :href="isindex == 1 ? getIplatPath() + '/html/home/home.html' : getIplatPath() + '/dist/index.html'"
          target="_blank">个人中心</a>
        <!-- <a v-else :href="getIplatPath()+'/html/'+roleName.roleName+'/main.html'">个人中心</a> -->
      </li>
      <li class="nav_more">
        <a class="username" :title="roleName.realName" @mousemove="moveName">
          <img :src="roleName.pic" class="photo" />
          {{ roleName.realName }}
        </a>
        <div class="nav_more_box" @mouseleave="leaveName">
          <em :style="roleName.roleList.length > 0
              ? roleName.roleName == 'tcadmin'
                ? 'margin-left: 30px;left:0;'
                : 'margin-left: 50px;left:0;'
              : 'left: 55%;'
            "></em>
          <ul class="clearfix role_list" :style="roleName.roleList.length > 0 ? 'width: auto;' : 'width: 100%;'
            ">
            <div v-for="(m, index) in roleName.roleList" :key="index">
              <!-- <li v-if="m.enName != roleName.roleName">
                <a v-text="'切换至：' + m.cName" @click="saveRole(m.memId)"></a>
              </li> -->
            </div>
            <li v-if="roleName.loginName == 'fifeduadmin'">
              <a :href="'https://static.fifedu.com/kmanage/upload_dir/kyxl-match-static/web/index.html?userId=' +
                roleName.userId
                " target="_blank">大赛管理</a>
            </li>
            <li>
              <a :href="getIplatPath() + '/html/user.html'">个人设置</a>
            </li>
            <li v-if="roleName.roleName != 'collegeadmin' &&
              roleName.roleName != 'sysadmin'
              ">
              <a :href="getIplatPath() + '/html/msg.html'">消息中心</a>
            </li>
            <li @click="backHome">
              <a>返回首页</a>
            </li>
            <li>
              <a @click="logout()">退出登录</a>
            </li>
          </ul>
        </div>
      </li>
      <!-- <iframe id="schoolIframe" src="#" frameborder="0" width="0px" height="0px"></iframe> -->
    </ul>
  </div>
</template>

<script>
import $ from "jquery";
import { EduSSO } from "../../static/utils/sso";
import { ShoolLogout } from "../request/api";
import { Process } from "../request/host";
export default {
  data() {
    return {
      isindex: "",
      role: "",
      nextpage: "",
      thisPage: "",
      roleList: [],
      tempId: 1, //模板id
      openAppList: [],
      cmsStatus: "",

      roleName: {
        roleName: "",
        realName: "",
        pic: "",
        logo: "",
        title: "",
        templateId: this.tempId,
        roleList: [],
        openAppList: this.openAppList,
        userId: "",
        loginName: "",
        nextpage: this.nextpage,
      },
    };
  },
  created() {
    //广西师大跳转
    this.getNextPage();
    this.initUser();
  },
  computed: {},
  methods: {
    backHome() {
      location.href = this.getIplatPath() + "/html/home/home.html";
    },
    getNextPage() {
      var nextpage = this.getRequest().nextpage
        ? this.getRequest().nextpage
        : undefined;
      this.nextpage = nextpage;
      if (nextpage) {
        sessionStorage.setItem("nextpage", nextpage);
      } else {
        nextpage = sessionStorage.getItem("nextpage");
      }
    },
    getRequest(_url) {
      var url = _url ? String(_url) : String(document.location); //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(url.indexOf("?") + 1);
        if (str.indexOf("#") != -1) {
          str = str.substr(0, str.indexOf("#"));
        }
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          var indexOfadd = strs[i].indexOf("=");
          if (indexOfadd > 0) {
            var key = strs[i].substr(0, indexOfadd);
            var value = strs[i].substr(indexOfadd + 1);
            theRequest[key] =
              (key in theRequest ? theRequest[key] + "," : "") + value;
          }
        }
      }
      return theRequest;
    },
    //获取主机url
    getHostPath() {
      var curWwwPath = window.document.location.href;
      var pathName = window.document.location.pathname;
      var pos = curWwwPath.indexOf(pathName);
      var localhostPath = curWwwPath.substring(0, pos);
      // http://bfsu.meixuego.com
      return localhostPath;
    },
    //获取iplat路径
    getIplatPath() {
      return this.getHostPath() + "/iplat"; //线上接口
    },
    //获取base路径
    getBasePath() {
      return this.getHostPath() + "/iplat/bp"; //线上接口
    },
    //获取base路径-CMS
    getBasePathCMS(m) {
      if (m != undefined) {
        return this.getHostPath() + "/iplat/cms"; //线上接口 //
      } else if (this.subDomain == false && this.thisPage == 1) {
        return "www"; //首页静态接口
      } else {
        return this.getHostPath() + "/iplat/cms"; //线上接口
      }
    },
    // 接口调用函数
    initData(url, datatype, dataval, opentype) {
      var mydata;
      if (opentype == "pop") {
        $(".loading")
          .css({ "background-color": "rgba(255,255,255,.6)" })
          .show();
      } else {
        $(".loading").css({ "background-color": "rgba(255,255,255,1)" }).show();
      }
      $.ajax({
        url: url,
        type: datatype,
        async: false, //同步
        data: dataval ? dataval : "",
        dataType: "json",
        timeout: 60000,
        success: function (data) {
          $(".loading").hide();
          if (data.status != "SUCCESS") {
            mydata = false;
            return;
          } else {
            mydata = data;
          }
        },
        error: function (e1, e2, e3) {
          $(".loading").hide();
          this.$message("网络开小差了，请稍后再试！");
        },
      });
      return mydata;
    },
    getIplatCasPath() {
      // 线上下
      var login = `${Process.env.VUE_APP_CYCORE}/cas-server`;
      // 测试
      // var login = "https://test.fifedu.com/cas-server";
      return login;
    },
    checkAppClick: function () {
      // 判断登录前是否点击过app
      var m = this;
      //判断是否点击app登录
      /* var getAppCode = sessionStorage.getItem("appCode"); // 取值
      if (getAppCode != null) {
        sessionStorage.removeItem("appCode"); // 删除 */
      for (var i = 0; i < this.openAppList.length; i++) {
        if (this.openAppList[i].code == getAppCode) {
          if (this.openAppList[i].buy == false) {
            $("#openBox-noBuy").show();
            return false;
          } else if (
            this.openAppList[i].buy == true &&
            this.openAppList[i].auth == false
          ) {
            $("#openBox-noAuth").show();
            return false;
          } else {
            top.location.href = this.openAppList[i].link;
            return false;
          }
        }
      }
      if (m.isSetAllow) {
        m.setUserName();
      }
    },
    moveName() {
      $(".nav_more_box").css({ transform: "scale(1)" });
    },
    leaveName() {
      $(".nav_more_box").css({ transform: "scale(0)" });
    },
    logout: function () {
      var loginurl = this.getIplatPath() + "/ssoservice";
      var edusso = new EduSSO(loginurl, this.getIplatCasPath());
      const that = this;
      sessionStorage.removeItem("isIndex");
      sessionStorage.removeItem("tempId");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("islogin");
      let domainName = this.getHostPath().split("//")[1].split(".")[0];
      edusso.logout(function (result) {
        sessionStorage.removeItem("appCode");
        if (result && result.result != "success") {
          that.$message(result.data);
        } else {
          if (that.nextpage != undefined) {
            top.location.href = that.nextpage;
          } else {
            that.thisPage = sessionStorage.getItem("tempId");
            that.$message(" 尊敬的用户 , 您已成功退出 ");
            setTimeout(() => {
              top.location.href =
                that.thisPage != undefined
                  ? "/iplat/dist/index.html"
                  : "/iplat/dist/index.html";
            }, 1000);
          }
          if (domainName == "aiit") {
            top.location.href =
              "http://in.aiit.edu.cn:8080/uaac-server/logout?service=https%3A%2F%2Fpass.fifedu.com%2Fiplat-pass%2FthirdLogin%2Faiit%2Flogin";
          } else if (domainName == "sdu") {
            top.location.href =
              "http://pass.sdu.edu.cn/cas/logout?service=https%3A%2F%2Fpass.fifedu.com%2Fiplat-pass%2FthirdLogin%2Fsdu%2Flogin";
          } else if (domainName == "wzu") {
            top.location.href =
              "https://source.wzu.edu.cn/logout?service=https%3A%2F%2Fpass.fifedu.com%2Fiplat-pass%2FthirdLogin%2Fwzu%2Flogin";
          }else if (domainName == "bjou") {
            top.location.href =
              "https://sso.bjou.edu.cn/logout";
          }
        }
      });
    },
    saveRole(memId) {
      const m = this;
      let saveData = m.initData(
        m.getBasePath() + "/member/changeUserRole",
        "post",
        "memId=" + memId,
        "pop"
      );
      if (saveData.status == "SUCCESS") {
        location.href = this.getIplatPath() + "/ssoservice";
        // location.href = this.getIplatPath() + "/dist/index.html";
      }
    },
    toPersonal() {
      top.location.href = this.getIplatPath() + "/html/eduadmin/main.html";
    },
    toUserCenter() {
      top.location.href =
        this.getIplatPath() + "/html/tcadmin/school_admin.html";
    },
    initUser: function () {
      var m = this;
      m.roleName.roleName = "";
      if (m.roleName.roleName == "") {
        var userInfoSrc = this.getBasePathCMS("m") + "/common/getUserName";
        var mydata;
        $(".loading").show();
        var local = window.document.location.href;
        var hrefName = local
          .split("?")[0]
          .split("/")
        [local.split("?")[0].split("/").length - 1].split(".")[0];
        this.hrefName = hrefName;
        $.ajax({
          url: userInfoSrc,
          type: "post",
          async: false, //同步
          data: "",
          dataType: "json",
          timeout: 5000,
          success: function (data) {
            $(".loading").hide();
            if (data.status == "SUCCESS") {
              let cmsStatus = data.data.status;
              m.cmsStatus = cmsStatus;
              m.isindex = 1;
            }else if (data.status == "401") {
              // 先退出登录
              var logouturl = `${Process.env.VUE_APP_CYCORE}/cas-server/logout`;
              sessionStorage.removeItem("isIndex");
              sessionStorage.removeItem("tempId");
              sessionStorage.removeItem("user");
              sessionStorage.removeItem("islogin");
              $.ajax({
                url: logouturl,
                type: "get",
                async: false, //同步
                timeout: 5000,
                dataType: 'jsonp',
                success: (result) => {
                  location.href = data.data;
                },
              });
              return;
            }
            // 二级域名下||设置了status=1的学校账户：获取模板id(刚开通二级域名但还未在首页管理中选择模板id时)
            if (m.subDomain == true || m.cmsStatus == 1) {
              //获取模板id
              var templateUrl = m.getBasePathCMS() + "/front/getPageIndex"; //模板id
              $(".loading").show();
              $.ajax({
                url: templateUrl,
                type: "post",
                async: false, //同步
                dataType: "json",
                timeout: 60000,
                success: function (data) {
                  $(".loading").hide();
                  if (data.status == "SUCCESS") {
                    m.roleName.templateId = data.data.pageIndex.templateId;
                    m.tempId = m.roleName.templateId;
                    m.cmsStatus = data.data.status;
                  } else {
                    if (m.subDomain == true) {
                      this.$message(data.message, Process.env.VUE_APP_ENV);
                    }
                  }
                },
                error: function (e1, e2, e3) {
                  $(".loading").hide();
                  this.$message("网络开小差了，请稍后再试！");
                },
              });
            }
            //二级域名下-获取头部信息
            if (m.subDomain == true && m.cmsStatus == 1) {
              var contentUrl = m.getBasePathCMS() + "/front/contentList"; //内容列表
              var baseInfo = m.initData(contentUrl, "post", "categoryId=1").data
                .contentList; //查基础信息类内容
              if (baseInfo.length > 0) {
                m.roleName.logo = baseInfo[0].picPath;
                m.roleName.title = baseInfo[0].shortName;
                $("head title").text(baseInfo[0].shortName);
                m.footImg = baseInfo[0].resizePath;
              } else {
                m.roleName.logo =
                  isindex != undefined
                    ? "images/logo_fif.png"
                    : "../images/logo_fif.png";
                m.roleName.title = "智慧教学平台";
                $("head title").text("智慧教学平台");
              }
            }
            if (hrefName == "index") {
              m.openAppList = m.initData(
                m.getBasePath() + "/common/getAllApplication",
                "post"
              ).data;
              if (data.data.member != undefined) {
                var name = data.data.member.loginName;
                name = name.toLowerCase();
                for (var i = 0; i < m.openAppList.length; i++) {
                  if (
                    "icet" == m.openAppList[i].code &&
                    m.openAppList[i].link != undefined
                  ) {
                    m.openAppList[i].link +=
                      "&u=" + name + "&p=" + sessionStorage.getItem(name);
                  }
                  if (
                    "akt" == m.openAppList[i].code &&
                    m.openAppList[i].link != undefined
                  ) {
                    var aktData = m.initData(
                      m.getBasePath() + "/member/akthref",
                      "post"
                    ).data;
                    m.openAppList[i].link = aktData.hrefurl;
                    $("#mainIndex").attr("src", aktData.url);
                    m.initData(aktData.url, "get");
                  }
                }
              }
              m.roleName.openAppList = openAppList;
            }
            if (data.status != "SUCCESS") {
            } else {
              m.userInfo = data;
              m.username = data.data.member.loginName;
              if (m.thisPage == 1 || m.thisPage == 3) {
                // 需登录的页面-判断该用户是否签署协议
                m.isAllowData = m.initData(
                  m.getIplatPath() + "/valid/allow",
                  "post",
                  "username=" + data.data.member.loginName,
                  "pop"
                ).data; //读取线上是否签署协议
                if (m.isAllowData.status == null || m.isAllowData.status == 1) {
                  //未签署
                  $("#openBox-allow").stop().show();
                  return;
                }
                m.checkAppClick();
              }
              m.setUserName();
            }
          },
          error: function (e1, e2, e3) {
            m.$message("请先登录");
            // top.location.href = "/dist/index.html";
          },
        });
      }
    },
    setUserName: function () {
      //用户信息
      var m = this;
      m.roleName.roleName = m.userInfo.data.member.roleName;
      m.roleName.userId = m.userInfo.data.member.id;
      m.roleName.realName = m.userInfo.data.member.name;
      m.roleName.loginName = m.userInfo.data.member.loginName;
      m.roleName.pic = m.getIplatPath() + m.userInfo.data.member.avatar;
      m.username = m.userInfo.data.member.loginName;
      /* username = m.userInfo.data.member.loginName;
      username = username.toLowerCase(); */
      m.initUserUrl();
      m.isLogin = true;
      m.subdomainsrc = m.userInfo.data.subdomain;
      if (m.roleName.roleName) {
        this, $;
      }
      //教师、负责人切换角色
      if (
        m.roleName.roleName == "teacher" ||
        m.roleName.roleName == "tcadmin"
      ) {
        var openData = m.initData(
          m.getBasePath() + "/member/getRoleList",
          "post"
        );
        if (openData.status == "SUCCESS") {
          m.roleName.roleList = openData.data;
        }
      }
    },
    initUserUrl: function () {
      var local = window.document.location.href;
      var localName = local.split("?")[0].split("/")[
        local.split("?")[0].split("/").length - 2
      ]; //所在文件夹名
      var hrefName = local
        .split("?")[0]
        .split("/")
      [local.split("?")[0].split("/").length - 2].split(".")[0]; //文件名
      if (
        (this.thisPage == undefined && localName != this.roleName.roleName) ||
        (this.cmsStatus == 0 && this.thisPage == 3)
      ) {
        // top.location.href = this.thisPage != undefined ? '/dist/index.html':'../index.html';
      }
      if (this.roleName.roleName == "collegeadmin" && hrefName == "msg") {
        // top.location.href = "index.html";
      }
    },
  },
};
</script>

<style scope lang="less">
#infoWrap {
  font-size: 14px;
  width: 160px;
  display: flex;
  justify-content: flex-end;

  /* 右侧-登录后*/
  .login_info {
    display: flex;
    font-size: 16px;
    align-items: center;
  }

  .login_info li {
    float: left;
    height: 22px;
    line-height: 22px;
    margin-left: 10px;
    position: relative;
    color: #e8f1f2;
  }

  .login_info li.line {
    width: 2px;
    font-size: 0;
    //   background: url(../images/line-header.png?v=2.0) center no-repeat;
  }

  .login_info li a {
    color: #e8f1f2;
    cursor: pointer;
    font-size: 16px;
    text-decoration: none;
  }

  .nav_more_box {
    width: 100%;
    top: 35px;
    left: 22px;
    position: absolute;
    z-index: 100;
    padding-top: 20px;

    .role_list {
      left: 25px !important;
      padding: 0 12px !important;
    }
  }

  .nav_more .nav_more_box em {
    position: absolute;
    top: -8px;
    left: 60%;
    margin-left: -11px;
    display: block;
    background: url("../assets/img/index1.png") -1535px -1342px no-repeat;
    width: 22px;
    height: 10px;
  }

  .nav_more .nav_more_box ul {
    width: auto;
    padding: 8px 5px;
    background-color: #fff;
    box-shadow: 0 11px 13px 0 rgba(0, 0, 0, 0.19);
    border-radius: 4px;
  }

  .nav_more_box li a:hover {
    color: #333;
    font-weight: bold;
    text-decoration: none;
  }

  .login_info .nav_more .nav_more_box ul li a {
    display: block;
    width: 100%;
    height: 20px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #4a4a4a;
    cursor: pointer;
  }

  .login_info li a.username {
    margin-left: 15px;
    padding-left: 30px;
    position: relative;
    max-width: 130px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .login_info .nav_more .nav_more_box ul li {
    float: none;
    width: 100%;
    height: 20px;
    padding: 5px 0;
    margin-left: 0;
  }

  .login_info li .username:hover,
  .login_info li .exit:hover {
    color: #fff;
    text-decoration: none;
  }

  .login_info li .username img.photo {
    position: absolute;
    left: 0;
    top: 0;
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }

  .nav_more .nav_more_box {
    position: absolute;
    z-index: 100;
    top: 40px;
    margin-left: -36px;
    font-weight: normal;
    transition: transform 0.25s ease;
    transform: scale(0);
    transform-origin: 50% 0%;
    white-space: nowrap;
  }

  .nav_more .nav_more_box .clearfix {
    width: auto;
    position: absolute;
    z-index: 100;
    top: 2px;
    font-weight: normal;
    white-space: nowrap;
    left: 25px;
    padding: 0 12px;
  }

  .clearfix::after {
    clear: both;
    content: " ";
    display: block;
    height: 0;
    overflow: hidden;
    line-height: 0;
  }

  .login_info li .role {
    float: left;
    color: #fff;
    position: relative;
  }

  .login_info li .role:hover {
    color: #fff;
    text-decoration: none;
  }

  .login_info li .role em {
    display: inline-block;
    cursor: pointer;
    height: 20px;
    margin-right: -5px;
    font-style: normal;
    padding-right: 15px;
  }

  .login_info li a.ico {
    float: left;
    margin-top: 2px;
    margin-left: 10px;
    display: block;
    width: 16px;
    height: 16px;
    background-repeat: no-repeat;
  }

  .login_info li a.home {
    margin-left: 0;
  }

  .login_info li a.ermai {
    margin-top: 4px;
    margin-left: 15px;
  }

  .login_info li a.msgbtn {
    position: relative;
  }

  .login_info li a.msgbtn i {
    position: absolute;
    top: 0;
    right: 0;
    width: 8px;
    height: 8px;
  }

  .login_info .nav_moreList {
    top: 20px;
    padding-top: 28px;
    right: 14px;
    left: auto;
    margin-left: 0;
  }

  .login_info .nav_moreList li {
    float: none;
    font-size: 16px;
    line-height: 28px;
    height: auto;
    margin-left: 0;
    padding: 0 10px;
  }
}</style>



// WEBPACK FOOTER //
// src/components/userinfo.vue